import PropTypes from "prop-types";
import ImageLogo from "components/utility/images/ImageLogo";
import ButtonAction from "components/utility/button/ButtonAction";

const NoAuthNav = (props) => {
	const { logoOnly, actionText, buttonText, buttonType, buttonLink } = props.dataset;

	return (
		<header className="header global-nav container container-noGutter-sm">
			<div className="header-content grid">
				<div className="col header-left-col">
					<div className="header-main">
						<a
							className="header-logo"
							href="/"
							data-a="true"
							data-a-cat="Navigation"
							data-a-act="Header"
							aria-label="Dimensional Investing | Dimensional Fund Advisors"
							data-a-evt="Navigation"
							data-a-name="Login Page"
							data-a-comp="Global Nav"
						>
							<ImageLogo />
						</a>
					</div>
				</div>
				{logoOnly === "true" ? (
					""
				) : (
					<div className="col-3 header-right-col global-nav-right-col">
						<h4 className="global-nav-link" data-testid="global-nav-link">
							{actionText}
						</h4>
						<ButtonAction
							url={buttonLink}
							type={buttonType}
							label={buttonText}
							width="full"
							dataA={true}
							dataALbl={buttonText}
							dataACat="Navigation"
							dataAAct="Header"
							dataAEvt="Navigation"
							dataALoc="Header"
							dataAText={buttonText}
							dataAComp="Global Nav"
						/>
					</div>
				)}
			</div>
			<hr />
		</header>
	);
};

NoAuthNav.propTypes = {
	dataset: PropTypes.shape({
		logoLink: PropTypes.string,
		actionText: PropTypes.string,
		buttonText: PropTypes.string,
		buttonType: PropTypes.string,
		buttonLink: PropTypes.string
	})
};

export default NoAuthNav;
